<script>
const CAPABILITIES = [
  {
    key: 'dm_enabled',
    icon: 'chat',
    labelKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.DM.LABEL',
    descriptionKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.DM.DESCRIPTION',
    testId: 'toggle-dm',
  },
  {
    key: 'comments_enabled',
    icon: 'comment-note',
    labelKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.COMMENTS.LABEL',
    descriptionKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.COMMENTS.DESCRIPTION',
    testId: 'toggle-comments',
  },
  {
    key: 'stories_enabled',
    icon: 'mention',
    labelKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.STORIES.LABEL',
    descriptionKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.STORIES.DESCRIPTION',
    testId: 'toggle-stories',
  },
  {
    key: 'human_agent_enabled',
    icon: 'clock',
    labelKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.HUMAN_AGENT.LABEL',
    descriptionKey: 'INBOX_MGMT.INSTAGRAM_CAPABILITIES.HUMAN_AGENT.DESCRIPTION',
    testId: 'toggle-human-agent',
  },
];

export default {
  name: 'InstagramCapabilitiesForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    pending: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { capabilities: CAPABILITIES };
  },
  methods: {
    onToggle(key, newValue) {
      this.$emit('input', { ...this.value, [key]: newValue });
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      v-for="cap in capabilities"
      :key="cap.key"
      data-test="capability-row"
      class="flex items-start gap-3 p-3 rounded-lg bg-slate-25 dark:bg-slate-800/40 border border-slate-50 dark:border-slate-800/60"
    >
      <div
        class="flex items-center justify-center w-8 h-8 rounded-full bg-woot-50 dark:bg-woot-800/30 flex-shrink-0"
      >
        <fluent-icon
          :icon="cap.icon"
          size="16"
          class="text-woot-500 dark:text-woot-400"
        />
      </div>
      <div class="flex-1 min-w-0">
        <div class="text-sm font-medium text-slate-700 dark:text-slate-100">
          {{ $t(cap.labelKey) }}
        </div>
        <div class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
          {{ $t(cap.descriptionKey) }}
        </div>
      </div>
      <woot-switch
        :data-test="cap.testId"
        :value="value[cap.key]"
        :disabled="!!pending[cap.key]"
        @input="onToggle(cap.key, $event)"
      />
    </div>
  </div>
</template>
